export enum TipoAlerta {
    Completado,
    Error,
    Informativa,
    Advertencia,
    DatosErroneos,
    CupoAsignado,
    ValidacionFacial
}
